module.exports = __webpack_public_path__ + "img/database.8a7491c3.png";